// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ICyH","newExpiryDate":"styles_newExpiryDate__RxXGt","footer":"styles_footer__1-BtJ"};